export default "__VITE_ASSET__B6m$KLmb__"